import { combineReducers } from 'redux'
import quickStart from './quickStart'
import announcements from './announcementState'
import threads from './threadsState'

export default combineReducers({
  quickStart,
  announcements,
  threads,
})
